import { runImpactCalculateFestivalCo2ForProject } from '@/domain/impact-calculate-festival/actions/run-impact-calculate-festival-co2-for-project.action';
import { runImpactCalculateTourCo2ForProject } from '@/domain/impact-calculate-tour/actions/run-impact-calculate-tour-co2-for-project.action';
import { runImpactCalculateVenueCo2ForProject } from '@/domain/impact-calculate-venue/actions/run-impact-calculate-venue-co2-for-project.action';
import { selectCurrentProjectMode } from '@/domain/project/project.selectors';
import { createAppAsyncThunk } from '@/domain/store.thunk';

type Params = {
  projectId: number;
};

type Result = void;

export const runImpactCalculateCo2ForProject = createAppAsyncThunk(
  'impactCalculate/runImpactCalculateCo2ForProject',
  async (params: Params, { dispatch, getState }): Promise<Result> => {
    const projectMode = selectCurrentProjectMode(getState());
    if (projectMode === 'festival') {
      dispatch(runImpactCalculateFestivalCo2ForProject(params));
    } else if (projectMode === 'venue') {
      dispatch(runImpactCalculateVenueCo2ForProject(params));
    } else if (projectMode === 'tour') {
      dispatch(runImpactCalculateTourCo2ForProject(params));
    }
  },
);
